import { render } from "./RouteDescriptionSkeleton.vue?vue&type=template&id=ddcb6306&scoped=true&lang=pug"
const script = {}

import "./RouteDescriptionSkeleton.vue?vue&type=style&index=0&id=ddcb6306&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ddcb6306"

export default script